import { APIGet, APIPost, APIPut, APIDelete, APIUrl, AdminType } from "api/protocols";
const apiVersion = "2024-04";
const adminType = "facility-admin";

export async function GetShifts(params: { date: string }, useGlobalLoader?: boolean) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/client/admin/shift-summary"), params, useGlobalLoader);
}
